/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Veteran = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Veteran"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#1F42F0"
        d="m12.388 16.922-4.687 4.546c-.733.71-1.92.71-2.652 0a1.78 1.78 0 0 1 0-2.572l4.688-4.545z"
      />
      <path
        fill="#F50"
        d="M7.426 3.864c2.563-2.485 6.719-2.485 9.282 0a6.23 6.23 0 0 1 0 9l-.039.036-2.007 1.838 4.289 4.159c.732.71.732 1.86 0 2.57-.733.71-1.92.71-2.652 0l-8.873-8.603a6.23 6.23 0 0 1 0-9m6.63 2.572a2.875 2.875 0 0 0-3.978 0 2.67 2.67 0 0 0 0 3.856l1.932 1.873 2.056-1.884a2.67 2.67 0 0 0-.01-3.845"
      />
    </g>
  </svg>
);

export const VeteranIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'veteran-icon'}
      icon={Veteran}
      {...props}
      size={size}
    />
  );
};
